<template>
<v-card :height="height" flat tile>
    <v-tabs v-model="tab" grow>
        <v-tab v-t="'Legal'"></v-tab>
        <v-tab v-t="'Manual'"></v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab" v-bind:style="bodyStyler">
        <v-tab-item class="pa-4" :height="height" flat tile style="overflow-y: auto">
            <h1 v-t="'Espec Web Controller'"></h1>
            <p v-if="version">
                {{$t('Firmware Version {0}', [version])}}
                <br/>
                <a @click="$store.commit('appSettings/showWhatsNew', true)" v-t="'New Features'"></a>
            </p>
            <p v-t="'Copyright 2023 ESPEC NORTH AMERICA'"></p>
            <p>
                <a
                    href="http://www.espec.com/na/support/wc_support"
                    v-t="'Web Controller Support Page'"
                ></a>
            </p>
            <template v-if="mender.artifact_name">
                <hr>
                <h1 v-t="'Firmware Image Report'"></h1>
                <p v-t="'Firmware version(s) as detailed by the firmware update system'"></p>
                <v-simple-table dense class="mb-2">
                    <thead>
                        <tr>
                            <th v-t="'Property'"></th>
                            <th v-t="'Version'"></th>
                            <th v-t="'Commit'"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(value, key) in mender" :key="key">
                            <template v-if="value.version && value.commit">
                                <th>{{key}}</th>
                                <td>{{value.version}}</td>
                                <td>{{value.commit}}</td>
                            </template>
                            <template v-else>
                                <th>{{key}}</th>
                                <td colspan="2">{{value}}</td>
                            </template>
                        </tr>
                    </tbody>
                </v-simple-table>
            </template>
            <template v-if="registration">
                <hr>
                <h1 v-t="'Registration'"></h1>
                <p v-t="'Details about chamber registration as shipped from the factor.'"></p>
                <v-simple-table dense class="mb-2">
                    <thead>
                        <tr>
                            <th v-t="'Serial Number'"></th>
                            <th v-t="'Customer'"></th>
                            <th v-t="'Shipped Firmware Version'"></th>
                            <th v-t="'Registration Date/Time'"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{{registration.serial}}</td>
                            <td>{{registration.customer}}</td>
                            <td>{{registration.version}}</td>
                            <td>{{registration.Datetime}}</td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </template>
            <template v-if="inspections">
                <hr>
                <h1 v-t="'Chamber Controller'"></h1>
                <p v-t="'Inspection details for the connected controller, used for setup verification.'"></p>
                <v-simple-table dense class="mb-2">
                    <thead>
                        <tr>
                            <th v-t="'Property'"></th>
                            <th v-t="'Value'"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(value, key) in inspections" :key="key">
                            <th>{{key}}</th>
                            <td>{{value}}</td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </template>
            <hr>
            <h1 v-t="'Terms of Service'"></h1>
            <tos></tos>
        </v-tab-item>
        <v-tab-item :style="{height: `${height}px`, width: '100%'}">
            <object :data="manualUrl"  type="application/pdf" height="100%" width="100%">
                <div v-t="'No online PDF viewer installed.'"></div>
            </object>
        </v-tab-item>
    </v-tabs-items>
</v-card>
</template>

<script>
import EspecChamberApi from '@/services/EspecChamberApi.js';
import appLayout from '@/mixins/appLayout.js';
import tos from '@/components/tos.vue';
import {serverOrigin} from '../services/Utils.js';
import EspecSetupApi from '../services/EspecSetupApi.js';

export default {
    mixins: [appLayout],
    components: { tos },
    data () { return {
        height: 400,
        tab: 0,
        inspections: null,
        mender: {},
    }},
    computed: {
        version () { return this.$store.getters['appSettings/version']; },
        registration () { return this.$store.getters['appSettings/registration'] },
        registrationDatetime () {
            try {
                return (new Date(this.registration.datetime)).toLocaleString()
            } catch (error) {
                return this.registration.datetime;
            }
        },
        manualUrl () {
            const relUrl = 'manual/manual.pdf'
            let originUrl = window.location.origin;
            return `${serverOrigin()}/${relUrl}`
        },
        bodyStyler () { return {
            'margin-left': this.drawerMargin,
            'height': `${this.height}px`,
            width: `calc(100% - ${this.drawerMargin})`,
            overflow: 'auto'
        } },
    },
    methods: {
        resize () { this.height = this.vMainHeight() - 48; },
        onResize () {
            //sometimes two resizes are required...
            this.resize();
            setTimeout(() => this.resize(), 250);
        }
    },
    mounted () {
        this.resize();
        window.addEventListener('resize', this.onResize);
        this.showDrawer = this.opened;
        if (this.$store.getters['auth/hasRole']('conditions')) {
            EspecChamberApi.getInspections().then(r => this.inspections = r.data);
            EspecSetupApi.getMenderFirmwareVersion().then(r => this.mender = r);
        }
    },
    beforeDestroy () {
        window.removeEventListener('resize', this.onResize);
    }
}
</script>
